// Featured collection slider
document.addEventListener("DOMContentLoaded", function() {
    const secCtr = document.querySelectorAll('.colllection__section-template-desktop-scrollable');
    secCtr.forEach(ctr => {
        const childElement = ctr.querySelectorAll('.grid-item')[0];
        const scrollContainer = ctr.querySelector(".featured-collection__slider");
        const scrollLeftBtn = ctr.querySelector(".featured-collection__scroll-left");
        const scrollRightBtn = ctr.querySelector(".featured-collection__scroll-right");
        scrollLeftBtn.addEventListener("click", function() {
            if (!scrollLeftBtn.classList.contains('is-scrolling')) {
                const width = childElement.offsetWidth;
                scrollContainer.scrollBy({
                    left: -width,
                    behavior: "smooth"
                });
            }
        });
        scrollRightBtn.addEventListener("click", function() {
            if (!scrollRightBtn.classList.contains('is-scrolling')) {
                const width = childElement.offsetWidth;
                scrollContainer.scrollBy({
                    left: width,
                    behavior: "smooth"
                });
            }
        });
    });
});

// Main product tabbed info
const tabs = document.querySelectorAll('.custom__tabs--tab');
const tabsBody = document.querySelectorAll('.custom__tabs--content-body');
if(tabs[0]) {
  tabs[0].classList.add('custom__tabs--tab-active')
}
if(tabsBody[0]) {
  tabsBody[0].classList.add('custom__tabs--show-active')
}
function activeClass(el) {
  for (const contentBody of tabsBody) {
      contentBody.classList.remove('custom__tabs--show-active')
  }
  document.getElementById(el.textContent.trim()).classList.add('custom__tabs--show-active');
  for (const tab of tabs) {
      tab.classList.remove('custom__tabs--tab-active');
  }
  el.classList.add('custom__tabs--tab-active');
}
for (const tab of tabs) {
  tab.addEventListener('click', function(event) {
      activeClass(event.currentTarget);
  })
}

// Quick add popup tabbed info
const quickProductBtns = document.querySelectorAll('.quick-product__btn');
quickProductBtns.forEach(btn => {
    btn.addEventListener('click', () => {
        const waitForElement = () => {
            const tabsToolTip = document.querySelectorAll('.custom__tabs--tab');
            const tabsBodyToolTip = document.querySelectorAll('.custom__tabs--content-body');
            if (tabsToolTip[0] && tabsBodyToolTip[0]) {
                // Your logic when the element is found
                tabsToolTip[0].classList.add('custom__tabs--tab-active');
                tabsBodyToolTip[0].classList.add('custom__tabs--show-active');
                function activeClass(el) {
                    for (const contentBody of tabsBodyToolTip) {
                        contentBody.classList.remove('custom__tabs--show-active');
                    }
                    document.getElementById(el.textContent.trim() + '-modal').classList.add('custom__tabs--show-active');
                    for (const tab of tabsToolTip) {
                        tab.classList.remove('custom__tabs--tab-active');
                    }
                    el.classList.add('custom__tabs--tab-active');
                }
                for (const tab of tabsToolTip) {
                    tab.addEventListener('click', function (event) {
                        activeClass(event.currentTarget);
                    });
                }
            } else {
                observer.observe(document, { subtree: true, childList: true });
            }
        };
        const observer = new MutationObserver(waitForElement);
        waitForElement();
    });
});
